import { render } from "./ProductsSection.vue?vue&type=template&id=24a4e99e&scoped=true&ts=true"
import script from "./ProductsSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsSection.vue?vue&type=script&setup=true&lang=ts"

import "./ProductsSection.vue?vue&type=style&index=0&id=24a4e99e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a4e99e"],['__file',"src/views/home-view/components/ProductsSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24a4e99e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24a4e99e', __exports__)) {
    api.reload('24a4e99e', __exports__)
  }
  
  module.hot.accept("./ProductsSection.vue?vue&type=template&id=24a4e99e&scoped=true&ts=true", () => {
    api.rerender('24a4e99e', render)
  })

}


export default __exports__